import { render, staticRenderFns } from "./ErrorCompleted.vue?vue&type=template&id=049ff140&"
import script from "./ErrorCompleted.vue?vue&type=script&lang=ts&"
export * from "./ErrorCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports